define.alias("shared/components/shared/user/info", "calendar/components/shared/user/info");